import script from "./ExtraInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&setup=true&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=5377adde&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5377adde"]])

export default __exports__